export default "__VITE_ASSET__C1Cr3vh5__"